//This function will map data structure from new api to old one
// Because we want to reuse this code which is based on /api/components/amrest_brands_in_countries
export default function mapData(divisions, countries, brands, brandsInCountries) {
  let mappedData = {};
  let mappedCountry = {};
  let numRestaurants = 0;

  mappedData["countries"] = [];

  for (const c of countries) {
    let countryId = c.field_division[0].target_id;
    let divisionData = getDivisionDataByDivisionId(countryId, divisions);
    let brandsInCountry = getBrandsInCountryByCountryId(c.id, brandsInCountries, brands);

    numRestaurants += parseInt(brandsInCountry.sum);

    mappedCountry = {
      division: divisionData.name,
      divisionCords: {
        lat: divisionData.lat,
        lng: divisionData.lng
      },
      country: c.name,
      brands: brandsInCountry.brands,
      count: brandsInCountry.sum,
      geoCords: {
        lat: c.field_coords[0].lat,
        lng: c.field_coords[0].lon
      }
    };
    mappedData["countries"].push(mappedCountry);
  }

  mappedData["countries"].sort((a, b) => a.country > b.country ? 1 : -1);

  mappedData.generalData = {
    numberOfRestaurants: numRestaurants,
    zoom: 6
  };

  return mappedData;
}

function getDivisionDataByDivisionId(id, divisions) {
  for (const d of divisions) {
    if (d.id === id) {
      return {
        name: d.name,
        lat: d.field_coords[0].lat,
        lng: d.field_coords[0].lon
      }
    }
  }
  console.error("No division data");
}

function getBrandsInCountryByCountryId(id, brandsInCountries, brands) {
  let brand;
  let brandsArray = [];
  let brandTaxonomyId;
  let brandData = {};
  let count;
  let franchises;
  let sum = 0;

  for (const b of brandsInCountries) {
    if (b.field_country[0].target_id === id) {
      brandTaxonomyId = b.field_brand[0].target_id;
      brandData = getBrandDataByBrandTaxonomyId(brandTaxonomyId, brands)
      count = b.field_restaurants_equity[0].value;
      franchises = b.field_restaurants_franchise[0].value;
      sum += parseInt(count) + parseInt(franchises);
      brand = {
        name: brandData.name,
        niceName: brandData.niceName,
        logoUrl: brandData.logoUrl,
        count: count,
        isFranchise: false
      };
      brandsArray.push(brand);
      if (franchises !== "0") {
        brand = {
          name: brandData.name,
          niceName: brandData.niceName,
          logoUrl: brandData.logoUrl,
          count: franchises,
          isFranchise: true
        };
        brandsArray.push(brand);
      }
    }
  }
  return {
    brands: brandsArray,
    sum: sum
  };
}

function getBrandDataByBrandTaxonomyId(id, brands) {
  for (const b of brands) {
    if (b.id === id) {
      return {
        name: b.field_machine_name[0].value,
        niceName: b.name,
        logoUrl: b.field_brand_logo[0].url,
      }
    }
  }
  console.error('No brand data');
}
